import { Link } from "react-router-dom";
import { AlertTriangle, ShieldCheck, Mail } from "lucide-react";
import NewsletterForm from "./NewsletterForm";

const FOOTER_LINKS = [
  {
    title: "Predictions",
    links: [
      { to: "/", label: "Today's Predictions" },
      { to: "/worldcup", label: "World Cup 2026" },
      { to: "/ipl", label: "IPL 2026" },
      { to: "/blog", label: "Sports AI Blog" },
      { to: "/analytics", label: "Live Analytics" },
    ],
  },
  {
    title: "Affiliates",
    links: [
      { to: "/best-betting-sites", label: "Best Betting Sites" },
      { to: "/casino-reviews", label: "Casino Reviews" },
    ],
  },
  {
    title: "Partners",
    links: [
      { to: "/advertise", label: "Advertise With Us" },
      { to: "/partners", label: "Partner Signup" },
      { to: "/media-kit", label: "Media Kit" },
      { to: "/tracking-demo", label: "Tracking & Retargeting" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
      { to: "/privacy-policy", label: "Privacy" },
      { to: "/terms", label: "Terms" },
    ],
  },
];

export default function ResponsibleGamblingFooter() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 mt-12" data-testid="rg-footer">
      {/* 18+ Disclaimer ribbon */}
      <div className="bg-gradient-to-r from-amber-500/15 via-amber-500/10 to-amber-500/15 border-y border-amber-500/30">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3 text-xs text-amber-200">
          <AlertTriangle className="w-4 h-4 shrink-0" />
          <span className="font-semibold">18+ Only · Play responsibly.</span>
          <span className="text-amber-200/70 hidden sm:inline">
            Gambling can be addictive. We provide analysis &amp; predictions only — no guaranteed winnings. If you need help, visit{" "}
            <a href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer" className="underline hover:text-amber-100">BeGambleAware.org</a>.
          </span>
        </div>
      </div>

      {/* Main grid */}
      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="text-xl font-extrabold text-white inline-flex items-center gap-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
              <ShieldCheck className="w-5 h-5 text-emerald-400" />
              SPORTSGURU247
            </Link>
            <p className="text-xs text-slate-500 mt-3 leading-relaxed">
              AI sports predictions, betting tips and iGaming traffic partnerships. Independently rated · Multi-language · 9 GEOs.
            </p>
            <a href="mailto:contact@sportsguru247.com" className="mt-4 inline-flex items-center gap-2 text-xs text-emerald-300 hover:text-emerald-200" data-testid="footer-partnerships-email">
              <Mail className="w-3.5 h-3.5" /> contact@sportsguru247.com
            </a>
          </div>
          {FOOTER_LINKS.map((col) => (
            <div key={col.title}>
              <div className="text-[10px] uppercase tracking-widest text-slate-500 mb-3 font-bold">{col.title}</div>
              <ul className="space-y-2 text-sm">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-slate-400 hover:text-emerald-300 transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-slate-800/60 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} SportsGuru247. All rights reserved.</span>
          <span className="text-slate-600">
            Predictions are statistical analysis, not guaranteed outcomes. Wording: "prediction", "analysis", "suggested bet" — never "sure win".
          </span>
        </div>
      </div>
    </footer>
  );
}
